(function () {
  'use strict';

  // ==========================================
  // 設定
  // ==========================================
  var normalPath = '/products/fujitsu-lifebook';
  var specialPath = '/products/kasse2611-fujitsu-lifebook';

  // 通常商品ページ以外では実行しない
  if (window.location.pathname !== normalPath) {
    return;
  }

  var params = new URLSearchParams(window.location.search);

  // ==========================================
  // 1. U748-Sからのアクセスを除外
  // ==========================================
  if (params.get('from') === 'u748s') {

    // 識別パラメータのみ削除
    params.delete('from');

    var remaining = params.toString();

    var cleanUrl =
      normalPath +
      (remaining ? '?' + remaining : '') +
      window.location.hash;

    window.history.replaceState(
      window.history.state,
      '',
      cleanUrl
    );

    return;
  }

  // ==========================================
  // 2. URLパラメータ付きのアクセスを除外
  // ==========================================
  if (
    window.location.search !== '' ||
    window.location.hash !== ''
  ) {
    return;
  }

  // ==========================================
  // 3. HTTPリダイレクト経由か確認
  // ==========================================
  var navEntries =
    window.performance.getEntriesByType('navigation');

  var nav = navEntries.length ? navEntries[0] : null;

  if (!nav || nav.redirectCount < 1) {
    return;
  }

  // ==========================================
  // 4. Shopifyの割引コードを確認
  // ==========================================
  var match = document.cookie.match(
    /(?:^|;\s*)discount_code=([^;]*)/
  );

  if (!match) {
    return;
  }

  var discountCode;

  try {
    discountCode = decodeURIComponent(match[1])
      .replace(/^"|"$/g, '');
  } catch (error) {
    return;
  }

  // KASSE2611以外は絶対に処理しない
  if (discountCode !== 'KASSE2611') {
    return;
  }

  // ==========================================
  // 5. KASSE専用商品へリダイレクト
  // ==========================================
  window.location.replace(specialPath);

})();